import isUndefined from 'lodash/isUndefined';

import { renderCurrency } from '../../components/SystemCountry';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

const { viewerIsNotAdmin } = tests;

export default [
  'PageSingle',
  {
    path: '/settings/general',
    title: 'General',
    headerTitle: 'General',
    renderHeaderTitle: () => 'General',
    hidden: false,
    activity: 'edit',
    url: '/settings/general',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave']],
    skip: [viewerIsNotAdmin],
    fields: [
      // ['FieldTitle', {
      //   title: 'VAT',
      //   icon: null,
      // }],
      // ['FieldText', {
      //   name: 'vat',
      //   label: null,
      //   prefix: 'VAT Percentage',
      //   initialValue: 0,
      //   type: 'number',
      //   align: 'right',
      //   addonAfter: '%',
      // }],
      ['FieldTitle', {
        title: 'Currencies',
        label: null,
      }],
      ['FieldSelect', {
        name: 'currencies',
        label: null,
        placeholder: 'List of currencies',
        choices: Types.CURRENCIES.map(currency => ({
          value: currency.code,
          label: `${currency.name} (${currency.code})`,
        })),
        mode: 'multiple',
      }],
      ['FieldTitle', {
        title: 'Payment Gateway',
        icon: null,
      }],
      ...Types.PAYMENT_PROVIDER_LIST.reduce(
        (agr, provider) => {
          if (provider.online) {
            agr.push(
              ['FieldTitle', {
                title: `${provider.label}`,
                icon: null,
                // eslint-disable-next-line max-len
                // style: { fontSize: '20px', marginBottom: '-15px' },
              }],
              ...(
                !provider.gatewayFeesBasedOnCardDetails
                ? [
                    ['FieldTitle', {
                      title: 'General',
                      size: 'small',
                      icon: null,
                      // eslint-disable-next-line max-len
                      style: { marginBottom: '-15px' },
                    }],
                    getFilterWithCol(['FieldText', {
                      name: `paymentGateway.${
                        provider.id
                      }.chargeAmountFixed`,
                      label: null,
                      prefix: 'Fixed Charge:',
                      initialValue: 0,
                      type: 'number',
                      align: 'right',
                      addonAfter: renderCurrency(),
                    }], 12),
                    getFilterWithCol(['FieldText', {
                      name: `paymentGateway.${
                        provider.id
                      }.chargeAmountPercentage`,
                      label: null,
                      prefix: 'Percentage Charge:',
                      initialValue: 0,
                      type: 'number',
                      align: 'right',
                      addonAfter: '%',
                    }], 12),
                  ]
                : []
              ),
              ...['National', 'International'].reduce(
                (agrCardBased, regionTitle) => {
                  agrCardBased.push(
                    ...(
                      provider.gatewayFeesBasedOnCardDetails
                      ? [
                          ['FieldTitle', {
                            title: regionTitle,
                            size: 'small',
                            icon: null,
                            // eslint-disable-next-line max-len
                            style: { marginBottom: '-15px' },
                          }],
                          getFilterWithCol(['FieldText', {
                            name: `paymentGateway.${provider.id}.${
                              regionTitle.toLowerCase()
                            }.chargeAmountFixed`,
                            label: null,
                            prefix: 'Fixed Charge:',
                            initialValue: 0,
                            type: 'number',
                            align: 'right',
                            addonAfter: renderCurrency(),
                          }], 12),
                          getFilterWithCol(['FieldText', {
                            name: `paymentGateway.${provider.id}.${
                              regionTitle.toLowerCase()
                            }.chargeAmountPercentage`,
                            label: null,
                            prefix: 'Percentage Charge:',
                            initialValue: 0,
                            type: 'number',
                            align: 'right',
                            addonAfter: '%',
                          }], 12),
                        ]
                      : []
                    )
                  );
                  return agrCardBased;
                },
                [],
              ),
            );
          }
          return agr;
        },
        [],
      ),
      ['FieldTitle', {
        title: 'Signing Up',
        icon: null,
      }],
      ['FieldSwitch', {
        name: 'signup.open',
        label: null,
        inlineLabelBefore: 'Allow Signups?',
      }],
      ['FieldTextArea', {
        name: 'signup.blacklist',
        label: null,
        // eslint-disable-next-line max-len
        placeholder: 'Blacklisted signup domains, eg: gmail.com, yahoo.com, etc.',
        autoSize: { minRows: 3 },
        prepareValueForForm: event => (
          isUndefined(event.target.value) || !event.target.value
          ? ' '
          : event.target.value
        ),
        prepareValueForInput: value => (
          value === ' '
          ? undefined
          : value
        ),
      }],
      // ['FieldTitle', {
      //   title: 'Expiry Notifications',
      //   // eslint-disable-next-line max-len
      //   subtitle: 'Notify the seller about the particular subscription ending at these periods.',
      //   icon: null,
      // }],
      // ...Types.STORE_EXPIREABLE_ITEMS.reduce(
      //   (agr, expireable) => {
      //     agr.push(
      //       ['FieldTitle', {
      //         title: expireable.label,
      //         size: 'small',
      //         icon: null,
      //       }],
      //       ['FieldSortableList', {
      //         name: `expireables.${expireable.id}`,
      //         label: null,
      //         maxCount: 3,
      //         head: 'horizontal',
      //         fields: [
      //           ['FieldSelect', {
      //             name: 'unit',
      //             label: null,
      //             prefix: 'Unit:',
      //             choices: Types.STORE_EXPIREABLE_PERIOD_UNIT_ITEMS.map(
      //               item => ({
      //                 value: item.id,
      //                 label: item.label,
      //               }),
      //             ),
      //             col: { span: 12 },
      //           }],
      //           ['FieldText', {
      //             name: 'count',
      //             label: null,
      //             initialValue: 1,
      //             prefix: 'Count:',
      //             type: 'number',
      //             col: { span: 12 },
      //           }],
      //         ],
      //       }],
      //     );
      //     return agr;
      //   },
      //   [],
      // ),
      ['FieldTitle', {
        title: 'Internal Stores',
        icon: null,
      }],
      ['FieldSortableList', {
        name: 'internalStores',
        label: null,
        fields: [
          ['FieldText', {
            name: 'label',
            label: null,
            prefix: 'Label:',
            col: { span: 12 },
          }],
          ['FieldConnectionSelect', {
            name: 'store',
            label: null,
            prefix: 'Store:',
            url: '/stores/list',
            searchPaths: ['name'],
            rules: [['validation.isRequired']],
            getExtraQueryConditions: () => [{
              internal: true,
            }],
            col: { span: 12 },
          }],
          ['FieldUploadRefsHorizontal', {
            name: 'image',
            label: null,
            maxCount: 1,
            accept: 'image/jpg,image/jpeg,image/png,image/webp',
            transformations: [
              ['GM', { command: 'compress', maxWidth: 120 }],
              ['GM', { command: 'webp' }],
            ],
            listType: 'picture',
            uploadLabel: 'Upload Icon',
          }],
        ],
      }],
    ],
  },
];
